import { REFERENCES } from '@/lib/referencesForLegacy'


export async function usePassRefs() {
  return async (legacyApp: any) => {
    legacyApp.$store.commit('references/SET_REFERENCES', REFERENCES)
    legacyApp.$store.commit('references/REFERENCES_INIT', 2)
  }
}
